import { render } from "./fleet_add.vue?vue&type=template&id=1bd9f49a"
import script from "./fleet_add.vue?vue&type=script&lang=js"
export * from "./fleet_add.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__